import { Text, Link, Grid } from "@hackthenorth/north";
import React from "react";
import styled from "styled-components";

import {
  OutlineDocument,
  PageWrapper,
  TOPNAVBAR_HEIGHT,
} from "src/shared/components";
import { Route } from "src/shared/constants/route";

import { GETTING_STARTED_SECTIONS } from "./constants";

const Section = styled.section`
  padding: 32px;
  border: 1px solid ${({ theme }) => theme.globalConstants.color.borderGrey};
  border-radius: ${({ theme }) => theme.globalConstants.borderRadius.medium}px;
  box-shadow: ${({ theme }) => theme.globalConstants.boxShadow.regular};
  background: ${({ theme }) => theme.globalConstants.color.white};
`;

const TableOfContents = styled(Section)`
  width: 329px;
`;

const StyledLink = styled(Link)`
  text-decoration: none !important;
  :hover {
    text-decoration: underline !important;
  }
`;

const SCROLL_OFFSET = 50;

const SectionScrollTarget = styled.div`
  position: relative;
  top: -${TOPNAVBAR_HEIGHT + SCROLL_OFFSET}px;
`;

const GETTING_STARTED_SHARE_ID = "274a7cf8-5da3-402e-9e52-4a0d71049f9a";

const GettingStarted: React.FC = () => (
  <PageWrapper scrollToTop>
    <Grid columns={1} rows="auto" rowGap={48}>
      <OutlineDocument shareId={GETTING_STARTED_SHARE_ID} />
      <TableOfContents>
        <Grid columns={1} rows="auto" rowGap={12}>
          <Text mods="heading h2">Table of contents</Text>
          {GETTING_STARTED_SECTIONS.map(({ label, sectionId }) => (
            <StyledLink
              mods="medium big"
              key={sectionId}
              href={`${Route.HACKER_GETTING_STARTED}/#${sectionId}`}
            >
              {label}
            </StyledLink>
          ))}
        </Grid>
      </TableOfContents>
      {GETTING_STARTED_SECTIONS.map(({ sectionId, shareId }) => (
        <Section key={sectionId}>
          <SectionScrollTarget id={sectionId} />
          <OutlineDocument shareId={shareId} noTitle />
        </Section>
      ))}
    </Grid>
  </PageWrapper>
);

export default GettingStarted;
